// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Rect$SmartcutsMacros = require("../../../Rect.bs.js");
var Command$SmartcutsMacros = require("../../../Command.bs.js");
var DOM__Node$SmartcutsMacros = require("../../../DOM__Node.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../../bs-utils/src/DeccoUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var DOM__FocusTrail$SmartcutsMacros = require("../../../DOM__FocusTrail.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../../DOM__HtmlElement.bs.js");
var ExtensionMessaging$SmartcutsMacros = require("../../../ExtensionMessaging.bs.js");
var PendingCommandInfo$SmartcutsMacros = require("../../../PendingCommandInfo.bs.js");
var Selection__Snapshot$SmartcutsMacros = require("../../../Selection/Selection__Snapshot.bs.js");
var Virtualized__InputMaps$SmartcutsMacros = require("../../../Virtualized__InputMaps.bs.js");
var HighlightElement__Shared$SmartcutsMacros = require("../../../HighlightElement__Shared.bs.js");
var DOM__Event__ForSerialization$SmartcutsMacros = require("../../../DOM__Event__ForSerialization.bs.js");
var StateMachine__DebounceManager$SmartcutsMacros = require("../../../StateMachine__DebounceManager.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../../ExtensionMessaging__FromExtension.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");
var Selection__ContentEditableSelectionOrCursor$SmartcutsMacros = require("../../../Selection/Selection__ContentEditableSelectionOrCursor.bs.js");
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = require("./ContentScript__StateMachine__RecordingMode__Shared.bs.js");

function retrieveCommandInfo_encode(v) {
  return [
          "RetrieveClipboardItemAsPasteInContentEditable",
          Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_encode(v._0)
        ];
}

function retrieveCommandInfo_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "RetrieveClipboardItemAsPasteInContentEditable") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Selection__ContentEditableSelectionOrCursor$SmartcutsMacros.ForRecordingAndAuthoring.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* RetrieveClipboardItemAsPasteInContentEditable */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function listener_encode(encoder_domEvent, v) {
  return [
          "DOMEventListener",
          Curry._1(encoder_domEvent, v._0)
        ];
}

function listener_decode(decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DOMEventListener") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DOMEventListener */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function debounceFirstCallData_encode(encoder_domHtmlElement, v) {
  return Js_dict.fromArray([
              [
                "pendingCommandKey",
                PendingCommandInfo$SmartcutsMacros.key_encode(v.pendingCommandKey)
              ],
              [
                "focusTrail",
                Decco.listToJson((function (param) {
                        return DOM__FocusTrail$SmartcutsMacros.Item.t_encode(encoder_domHtmlElement, param);
                      }), v.focusTrail)
              ],
              [
                "firstTimestamp",
                Decco.floatToJson(v.firstTimestamp)
              ]
            ]);
}

function debounceFirstCallData_decode(decoder_domHtmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var pendingCommandKey = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingCommandKey"), null));
  if (pendingCommandKey.TAG === /* Ok */0) {
    var focusTrail = Decco.listFromJson((function (param) {
            return DOM__FocusTrail$SmartcutsMacros.Item.t_decode(decoder_domHtmlElement, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusTrail"), null));
    if (focusTrail.TAG === /* Ok */0) {
      var firstTimestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstTimestamp"), null));
      if (firstTimestamp.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  pendingCommandKey: pendingCommandKey._0,
                  focusTrail: focusTrail._0,
                  firstTimestamp: firstTimestamp._0
                }
              };
      }
      var e = firstTimestamp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".firstTimestamp" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = focusTrail._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".focusTrail" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = pendingCommandKey._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".pendingCommandKey" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function debounceManager_encode(encoder_domEvent, encoder_domHtmlElement, v) {
  return StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, (function (param) {
                return debounceFirstCallData_encode(encoder_domHtmlElement, param);
              }), v);
}

function debounceManager_decode(decoder_domEvent, decoder_domHtmlElement, v) {
  return StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, (function (param) {
                return debounceFirstCallData_decode(decoder_domHtmlElement, param);
              }), v);
}

function streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "inputByDomElementRepresentation",
                Curry._1(encoder_inputByDomElementRepresentation, v.inputByDomElementRepresentation)
              ],
              [
                "currentSelection",
                Selection__Snapshot$SmartcutsMacros.Generic.t_encode(encoder_domNode, v.currentSelection)
              ],
              [
                "focusTrail",
                Decco.listToJson((function (param) {
                        return DOM__FocusTrail$SmartcutsMacros.Item.t_encode(encoder_domHtmlElement, param);
                      }), v.focusTrail)
              ],
              [
                "maybeClickContext",
                Decco.optionToJson(encoder_domEvent, v.maybeClickContext)
              ],
              [
                "debounceManager",
                debounceManager_encode(encoder_domEvent, encoder_domHtmlElement, v.debounceManager)
              ]
            ]);
}

function streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var inputByDomElementRepresentation = Curry._1(decoder_inputByDomElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "inputByDomElementRepresentation"), null));
  if (inputByDomElementRepresentation.TAG === /* Ok */0) {
    var currentSelection = Selection__Snapshot$SmartcutsMacros.Generic.t_decode(decoder_domNode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "currentSelection"), null));
    if (currentSelection.TAG === /* Ok */0) {
      var focusTrail = Decco.listFromJson((function (param) {
              return DOM__FocusTrail$SmartcutsMacros.Item.t_decode(decoder_domHtmlElement, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "focusTrail"), null));
      if (focusTrail.TAG === /* Ok */0) {
        var maybeClickContext = Decco.optionFromJson(decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeClickContext"), null));
        if (maybeClickContext.TAG === /* Ok */0) {
          var debounceManager = debounceManager_decode(decoder_domEvent, decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debounceManager"), null));
          if (debounceManager.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      inputByDomElementRepresentation: inputByDomElementRepresentation._0,
                      currentSelection: currentSelection._0,
                      focusTrail: focusTrail._0,
                      maybeClickContext: maybeClickContext._0,
                      debounceManager: debounceManager._0
                    }
                  };
          }
          var e = debounceManager._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".debounceManager" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = maybeClickContext._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".maybeClickContext" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = focusTrail._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".focusTrail" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = currentSelection._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".currentSelection" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = inputByDomElementRepresentation._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".inputByDomElementRepresentation" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  if (typeof v === "number") {
    if (v === /* Init */0) {
      return ["Init"];
    } else {
      return ["SettingUpEventStreamingToBg"];
    }
  }
  switch (v.TAG | 0) {
    case /* StreamingEventsToBg */0 :
        return [
                "StreamingEventsToBg",
                streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0)
              ];
    case /* HighlightingElementWhileStreamingEventsToBg */1 :
        return [
                "HighlightingElementWhileStreamingEventsToBg",
                streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0),
                HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._1)
              ];
    case /* Exiting */2 :
        return [
                "Exiting",
                exiting_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
              ];
    case /* Exited */3 :
        return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
                      }), v._0)
              ];
    
  }
}

function sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* SetupEventStreaming */0 :
          return ["SetupEventStreaming"];
      case /* TeardownEventStreaming */1 :
          return ["TeardownEventStreaming"];
      case /* RenderModalToExplainHighlightElement */2 :
          return ["RenderModalToExplainHighlightElement"];
      case /* RenderHighlightElementControl */3 :
          return ["RenderHighlightElementControl"];
      case /* RemoveRenderedContent */4 :
          return ["RemoveRenderedContent"];
      case /* TellBgToStopHighlightingElement */5 :
          return ["TellBgToStopHighlightingElement"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Dispatch */0 :
          return [
                  "Dispatch",
                  event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
      case /* StreamCommandToBgToRecordIt */1 :
          return [
                  "StreamCommandToBgToRecordIt",
                  Command$SmartcutsMacros.CommandWithContextLocal.t_encode(v._0),
                  Decco.optionToJson((function (param) {
                          return [
                                  PendingCommandInfo$SmartcutsMacros.key_encode(param[0]),
                                  Decco.intToJson(param[1])
                                ];
                        }), v._1)
                ];
      case /* NotifyBgAboutPossibleCommand */2 :
          return [
                  "NotifyBgAboutPossibleCommand",
                  PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                  Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v._1)
                ];
      case /* ResetDebounceTimeout */3 :
          return [
                  "ResetDebounceTimeout",
                  StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0),
                  Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
      case /* RespondToBg */4 :
          return [
                  "RespondToBg",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_encode(v._1)
                ];
      case /* StreamCommandToBgForHighlightedElement */5 :
          return [
                  "StreamCommandToBgForHighlightedElement",
                  Curry._1(encoder_domHtmlElement, v._0),
                  HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._1)
                ];
      case /* RetrievePossibleCommandInfoAndMaybeStreamToBg */6 :
          return [
                  "RetrievePossibleCommandInfoAndMaybeStreamToBg",
                  PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
                  retrieveCommandInfo_encode(v._1),
                  extraInfoRetrieveCommandInfo_encode(v._2)
                ];
      
    }
  }
}

function event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* DidSetupEventStreaming */0 :
          return ["DidSetupEventStreaming"];
      case /* DidTeardownEventStreaming */1 :
          return ["DidTeardownEventStreaming"];
      case /* ShouldNotShowUserExplainHighlightModal */2 :
          return ["ShouldNotShowUserExplainHighlightModal"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Initialize */0 :
          return [
                  "Initialize",
                  Decco.optionToJson((function (param) {
                          return [
                                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(param[0]),
                                  ExtensionMessaging$SmartcutsMacros.rejectToTab_encode(param[1])
                                ];
                        }), v._0)
                ];
      case /* DidSetNewDebounceTimeout */1 :
          return [
                  "DidSetNewDebounceTimeout",
                  StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0),
                  DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
      case /* DebounceTimerExpired */2 :
          return [
                  "DebounceTimerExpired",
                  StateMachine__DebounceManager$SmartcutsMacros.uuid_encode(v._0)
                ];
      case /* DidFlushDebouncedEvent */3 :
          return [
                  "DidFlushDebouncedEvent",
                  StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, (function (param) {
                          return debounceFirstCallData_encode(encoder_domHtmlElement, param);
                        }), v._0)
                ];
      case /* UserDidSelectElement */4 :
          return [
                  "UserDidSelectElement",
                  Curry._1(encoder_domHtmlElement, v._0)
                ];
      case /* SharedEvent */5 :
          return [
                  "SharedEvent",
                  ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
                ];
      case /* BasicEventWhileEventStreaming */6 :
          return [
                  "BasicEventWhileEventStreaming",
                  ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
      case /* Fail */7 :
          return [
                  "Fail",
                  failure_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
      case /* Exit */8 :
          return [
                  "Exit",
                  exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v._0)
                ];
      
    }
  }
}

function exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return listener_encode(encoder_domEvent, param);
              }), otherFailureReason_encode, v);
}

function exiting_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  return Js_dict.fromArray([
              [
                "didTeardownEventStreaming",
                Decco.boolToJson(v.didTeardownEventStreaming)
              ],
              [
                "debounceStatusForExit",
                debounceStatusForExit_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v.debounceStatusForExit)
              ],
              [
                "allExitReasons",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
                      }), v.allExitReasons)
              ]
            ]);
}

function exiting_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var didTeardownEventStreaming = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didTeardownEventStreaming"), null));
  if (didTeardownEventStreaming.TAG === /* Ok */0) {
    var debounceStatusForExit = debounceStatusForExit_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debounceStatusForExit"), null));
    if (debounceStatusForExit.TAG === /* Ok */0) {
      var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
              return exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
      if (allExitReasons.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  didTeardownEventStreaming: didTeardownEventStreaming._0,
                  debounceStatusForExit: debounceStatusForExit._0,
                  allExitReasons: allExitReasons._0
                }
              };
      }
      var e = allExitReasons._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".allExitReasons" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = debounceStatusForExit._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".debounceStatusForExit" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = didTeardownEventStreaming._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".didTeardownEventStreaming" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return listener_decode(decoder_domEvent, param);
              }), otherFailureReason_decode, v);
}

function event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventWhileEventStreaming" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventWhileEventStreaming */6,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DebounceTimerExpired" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DebounceTimerExpired */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DidFlushDebouncedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, (function (param) {
                  return debounceFirstCallData_decode(decoder_domHtmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFlushDebouncedEvent */3,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DidSetNewDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidSetNewDebounceTimeout */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$3 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "DidSetupEventStreaming" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidSetupEventStreaming */0
                  };
          }
      case "DidTeardownEventStreaming" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidTeardownEventStreaming */1
                  };
          }
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */8,
                      _0: v0$3._0
                    }
                  };
          }
          var e$5 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = failure_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */7,
                      _0: v0$4._0
                    }
                  };
          }
          var e$6 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.optionFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(v0);
                  var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToTab_decode(v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Initialize */0,
                      _0: v0$5._0
                    }
                  };
          }
          var e$7 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "SharedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SharedEvent */5,
                      _0: v0$6._0
                    }
                  };
          }
          var e$8 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "ShouldNotShowUserExplainHighlightModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ShouldNotShowUserExplainHighlightModal */2
                  };
          }
      case "UserDidSelectElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UserDidSelectElement */4,
                      _0: v0$7._0
                    }
                  };
          }
          var e$9 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotifyBgAboutPossibleCommand" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NotifyBgAboutPossibleCommand */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "RemoveRenderedContent" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveRenderedContent */4
                  };
          }
      case "RenderHighlightElementControl" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderHighlightElementControl */3
                  };
          }
      case "RenderModalToExplainHighlightElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderModalToExplainHighlightElement */2
                  };
          }
      case "ResetDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = StateMachine__DebounceManager$SmartcutsMacros.uuid_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ResetDebounceTimeout */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$3 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "RespondToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.result_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RespondToBg */4,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$5 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "RetrievePossibleCommandInfoAndMaybeStreamToBg" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = retrieveCommandInfo_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$9 = extraInfoRetrieveCommandInfo_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              if (match$9.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* RetrievePossibleCommandInfoAndMaybeStreamToBg */6,
                          _0: match$7._0,
                          _1: match$8._0,
                          _2: match$9._0
                        }
                      };
              }
              var e$7 = match$9._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "SetupEventStreaming" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SetupEventStreaming */0
                  };
          }
      case "StreamCommandToBgForHighlightedElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$10 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$11 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$10.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* StreamCommandToBgForHighlightedElement */5,
                        _0: match$10._0,
                        _1: match$11._0
                      }
                    };
            }
            var e$10 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "StreamCommandToBgToRecordIt" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$12 = Command$SmartcutsMacros.CommandWithContextLocal.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$13 = Decco.optionFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = PendingCommandInfo$SmartcutsMacros.key_decode(v0);
                  var match$3 = Decco.intFromJson(v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$12.TAG === /* Ok */0) {
            if (match$13.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* StreamCommandToBgToRecordIt */1,
                        _0: match$12._0,
                        _1: match$13._0
                      }
                    };
            }
            var e$12 = match$13._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "TeardownEventStreaming" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TeardownEventStreaming */1
                  };
          }
      case "TellBgToStopHighlightingElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TellBgToStopHighlightingElement */5
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Exited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                  return exitReason_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exited */3,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Exiting" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = exiting_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exiting */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "HighlightingElementWhileStreamingEventsToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* HighlightingElementWhileStreamingEventsToBg */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      case "SettingUpEventStreamingToBg" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SettingUpEventStreamingToBg */1
                  };
          }
      case "StreamingEventsToBg" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* StreamingEventsToBg */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function debounceStatusForExit_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AwaitingAllDebouncedEventsToFlush" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = streamingState_decode(decoder_inputByDomElementRepresentation, decoder_domNode, decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* AwaitingAllDebouncedEventsToFlush */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FlushedAllDebouncedEvents" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FlushedAllDebouncedEvents */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function failure_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return listener_decode(decoder_domEvent, param);
              }), otherFailureReason_decode, v);
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function extraInfoRetrieveCommandInfo_encode(v) {
  return Js_dict.fromArray([
              [
                "targetBoundingRect",
                Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v.targetBoundingRect)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ],
              [
                "insertAfterOffset",
                Decco.intToJson(v.insertAfterOffset)
              ]
            ]);
}

function extraInfoRetrieveCommandInfo_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetBoundingRect = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetBoundingRect"), null));
  if (targetBoundingRect.TAG === /* Ok */0) {
    var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
    if (timestamp.TAG === /* Ok */0) {
      var insertAfterOffset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "insertAfterOffset"), null));
      if (insertAfterOffset.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  targetBoundingRect: targetBoundingRect._0,
                  timestamp: timestamp._0,
                  insertAfterOffset: insertAfterOffset._0
                }
              };
      }
      var e = insertAfterOffset._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".insertAfterOffset" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = timestamp._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".timestamp" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = targetBoundingRect._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetBoundingRect" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function failure_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return listener_encode(encoder_domEvent, param);
              }), otherFailureReason_encode, v);
}

function debounceStatusForExit_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v) {
  if (v) {
    return [
            "AwaitingAllDebouncedEventsToFlush",
            streamingState_encode(encoder_inputByDomElementRepresentation, encoder_domNode, encoder_domHtmlElement, encoder_domEvent, v._0)
          ];
  } else {
    return ["FlushedAllDebouncedEvents"];
  }
}

function errorContext_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return event_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domEvent, encoder_inputByDomElementRepresentation, encoder_domHtmlElement, encoder_domNode, param);
              }), (function (param) {
                return listener_encode(encoder_domEvent, param);
              }), v);
}

function errorContext_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return event_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domEvent, decoder_inputByDomElementRepresentation, decoder_domHtmlElement, decoder_domNode, param);
              }), (function (param) {
                return listener_decode(decoder_domEvent, param);
              }), v);
}

var Generic = {
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  debounceFirstCallData_encode: debounceFirstCallData_encode,
  debounceFirstCallData_decode: debounceFirstCallData_decode,
  debounceManager_encode: debounceManager_encode,
  debounceManager_decode: debounceManager_decode,
  streamingState_encode: streamingState_encode,
  streamingState_decode: streamingState_decode,
  state_encode: state_encode,
  state_decode: state_decode,
  exiting_encode: exiting_encode,
  exiting_decode: exiting_decode,
  debounceStatusForExit_encode: debounceStatusForExit_encode,
  debounceStatusForExit_decode: debounceStatusForExit_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  extraInfoRetrieveCommandInfo_encode: extraInfoRetrieveCommandInfo_encode,
  extraInfoRetrieveCommandInfo_decode: extraInfoRetrieveCommandInfo_decode
};

var Regular = {};

function listener_encode$1(v) {
  return listener_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function listener_decode$1(v) {
  return listener_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function state_encode$1(v) {
  return state_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function state_decode$1(v) {
  return state_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function event_encode$1(v) {
  return event_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function event_decode$1(v) {
  return event_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function sideEffect_encode$1(v) {
  return sideEffect_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function sideEffect_decode$1(v) {
  return sideEffect_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function failure_encode$1(v) {
  return failure_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function failure_decode$1(v) {
  return failure_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function errorContext_encode$1(v) {
  return errorContext_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function errorContext_decode$1(v) {
  return errorContext_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

function exitReason_encode$1(v) {
  return exitReason_encode(DOM__Event__ForSerialization$SmartcutsMacros.t__encode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, v);
}

function exitReason_decode$1(v) {
  return exitReason_decode(DOM__Event__ForSerialization$SmartcutsMacros.t__decode, Virtualized__InputMaps$SmartcutsMacros.VirtualizedInputBySelector.t_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, v);
}

var otherFailureReason_encode$1 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

var otherFailureReason_decode$1 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

var ForSerialization = {
  listener_encode: listener_encode$1,
  listener_decode: listener_decode$1,
  state_encode: state_encode$1,
  state_decode: state_decode$1,
  event_encode: event_encode$1,
  event_decode: event_decode$1,
  sideEffect_encode: sideEffect_encode$1,
  sideEffect_decode: sideEffect_decode$1,
  failure_encode: failure_encode$1,
  failure_decode: failure_decode$1,
  errorContext_encode: errorContext_encode$1,
  errorContext_decode: errorContext_decode$1,
  exitReason_encode: exitReason_encode$1,
  exitReason_decode: exitReason_decode$1,
  otherFailureReason_encode: otherFailureReason_encode$1,
  otherFailureReason_decode: otherFailureReason_decode$1
};

exports.retrieveCommandInfo_encode = retrieveCommandInfo_encode;
exports.retrieveCommandInfo_decode = retrieveCommandInfo_decode;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* Rect-SmartcutsMacros Not a pure module */
